import { render, staticRenderFns } from "./AgrupadorPromos.vue?vue&type=template&id=6d0b4e94&scoped=true"
import script from "./AgrupadorPromos.vue?vue&type=script&lang=js"
export * from "./AgrupadorPromos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b4e94",
  null
  
)

export default component.exports